import { FilterGroup } from '@/service/type/Filter';
import { isEmpty } from 'lodash-es';

interface FilterBalanceProps {
  filter: FilterGroup;
  currentStrength: number;
  isSelected: boolean;
}

export const getFilterBalance = ({ filter, currentStrength, isSelected }: FilterBalanceProps) => {
  const sfList = filter?.sf_list ?? [];

  if (isEmpty(sfList)) {
    return {
      balance: 0,
      hasWarning: false,
    };
  }

  let balance = 0;

  if (!isSelected) {
    balance = sfList.reduce((acc, curr) => acc + (curr.balance ?? 0), 0);
  } else {
    const key = currentStrength === 0 ? 'low' : 'high';
    balance = sfList.find((sf) => sf.key === key)?.balance ?? 0;
  }

  const hasWarning = balance > 0 && balance <= 3;

  return {
    balance,
    hasWarning,
  };
};
